export const isMobile = JSON.parse(localStorage.getItem("__extraconomy_ismobile__"));
